import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services'
import { checkTranslation, translate } from '../../utils/useful'
import IntractionActionsList from '../IntractionActionsList'
import Modal from '../Modal'
import StagesManager from '../StagesManager'
import SendToAction from './SendToAction'
import SendToMain from './SendToMain'
import importedIcons from '../inputs/icons'

export default class SendTo extends Component {
    state = {
        actions: {

            taskList: { key: "TaskList", label: '{{lang}}Task List', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', icon: importedIcons.tasking },
            sprintList: { key: "sprintList", label: '{{lang}}Sprint List', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', icon: importedIcons.sprint },

        },
        frameList: [],
    }
    actionClicked = (prop, data, index) => {
        // console.log('prop', prop)
        this.showFrames(prop)

    }
    transferTask = (withSub) => {
        let body = {
            _id: this.props.data._id,
            frame: this.state.currentSprint._id,
            withSub
        }
        if (this.state.sprint) {
            body.sprint = this.state.sprint._id
        }
        HttpServices.request('transportFrame', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
        })
    }
    sendToAction = (prop, sprint) => {
        console.log('sendToAction')
        // console.log('this.props.data', this.props.data)
        // console.log('this.props.data c', this.props.data['*children'])
        // console.log('this.props.data check', this.props.data['*children']?.length != 0)
        if (Array.isArray(this.props.data['*children']) && this.props.data['*children']?.length != 0) {
            this.setState({ currentSprint: prop, sprint }, () => {
                this.sendActionModal.open()
            })
        }
        else {

            let body = {
                _id: this.props.data._id,
                frame: prop._id,
            }
            if (sprint) {
                body.sprint = sprint._id
            }
            HttpServices.request('transportFrame', body, (fetchResult, fetchError) => {
                if (fetchError) {
                    return
                }
            })
        }
    }
    showFrames = (prop) => {
        let data = {
            applet: this.props.applet._id,
            appletHub: this.props.applet.hub
        }
        // console.log('prop.key', prop.key)
        if (prop.key == 'list') {
            data.mode = 'tasklist'
        }
        else if (prop.key == 'sprintList') {
            data.mode = 'sprint'
        }
        // console.log('data',data)
        HttpServices.request('getFrames', data, (fetchResult, fetchError) => {
            // console.log('fetchRes', fetchResult.info)
            // console.log('fetchRes!', fetchResult.recordGroups)
            this.setState({ frameList: fetchResult.info, recordGroups: fetchResult.recordGroups, section: prop }, () => {
                this.stageManager.changeStage('action')
            })
        })

    }
    lastPage = () => {
        this.stageManager.lastStage()
    }
    render() {
        return (
            <div>
                <StagesManager ref={e => this.stageManager = e} width={100} fast={true} >
                    <SendToMain lastPage={this.props.lastPage} data={this.props.data} index={this.props.index} stage={0} stageName='main' actionClicked={this.actionClicked} actions={this.state.actions} language={this.props.language} />
                    <SendToAction recordGroups={this.state.recordGroups} section={this.state.section} lastPage={this.lastPage} stageName='action' data={this.state.frameList} sendToAction={this.sendToAction} />
                </StagesManager>
                <Modal width={'100%'} maxWidth={350} ref={el => this.sendActionModal = el}>
                    <div className='flexcc p-3 br-15 flex-column m-5' style={{ backgroundColor: "#fff" }}>
                        <p>Do you want to move just this task or with their sub-tasks?</p>
                        <div className='mt-4 flexc w-100'>
                            <button className='px-3 py-2 br-5 mrd-3 w-100' style={{ backgroundColor: '#21a814' }} onClick={() => this.transferTask(false)}>
                                <p className='font-size-14 white'>{translate('without subtask')}</p>
                            </button>
                            <button className='px-3 py-2 br-5 mld-3 w-100' style={{ backgroundColor: '#21a814' }} onClick={() => this.transferTask(true)}>
                                <p className='font-size-14 white'>{translate('with subtask')}</p>
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}
